import { useMutation } from "@tanstack/react-query";
import axios from "axios";

const updateFolderName = async (data) => {
  const { projectId, folder, name, displayName } = data;

  try {
    const response = await axios.patch(
      `/api/rename-folder/${projectId}/${folder.id}/`,
      { name, displayName },
      { withCredentials: true },
    );
    return response.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.message || "Failed to update folder name",
    );
  }
};

export const useUpdateFolderName = (
  queryClient,
  projectId,
  userType,
  enqueueSnackbar,
  setOpen,
) => {
  return useMutation({
    mutationFn: updateFolderName,
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: ["all-project-structure", projectId, userType],
      });
      enqueueSnackbar("Folder name updated successfully", {
        variant: "success",
      });
      setOpen(false);
    },
    onError: (err) => {
      console.error("UPDATE FOLDER NAME ERROR", err);
      enqueueSnackbar("Error updating folder name", { variant: "error" });
    },
  });
};
